'use strict';

// recoverSSE recovers a dropped Server-Sent Events connection.
//
// The access token rides in the stream URL (EventSource can't send headers), and
// once it expires the server replies 401 — which the browser surfaces only as a
// generic `error` event with no status. A naive reconnect reuses the same stale
// token and 401-loops forever, silently killing live notifications until a page
// reload.
//
// The fix: refresh the token first. On success tryRefresh saves the new token and
// reconnects SSE itself (via window.__reconnectSSE), so we must NOT reconnect
// again here. Only when the refresh fails do we fall back to reconnecting with
// the existing token (covers transient network drops where the token is still
// valid; a truly dead session keeps failing under the caller's backoff).
//
// Dependencies are injected so the decision is unit-testable without a browser.
export async function recoverSSE({ hasToken, tryRefresh, reconnect }) {
  if (!hasToken()) return; // logged out — nothing to recover
  const refreshed = await tryRefresh();
  if (!refreshed) reconnect();
}
